import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { on } from 'events';

// https://netbasal.com/how-to-implement-file-uploading-in-angular-reactive-forms-89a3fffa1a03

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss'],
})
export class FileUploadComponent implements OnInit {
  @Input() accept = '';
  @Input() multiple = false;
  @Input() inputId = '';
  @Output() change = new EventEmitter();

  constructor(private host: ElementRef<HTMLInputElement>) {}

  ngOnInit() {}

  onFileSelected(event: Event) {
    const files = (event.target as HTMLInputElement).files;
    this.change.emit(files);
  }
}
